import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_textile_pillows: FaireCollectionEntity = {
  token: "col_textile-pillows",
  type: "collection",
  name: "Textile Pillows",
  description: "Decorative throw pillows in various styles.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  season: "everyday",
  itemCount: 112,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
